<template>
  <div id>
    <div class="container" style="margin-bottom: 80px">
      <div class="sub-title mt20" style="position: relative">
        <p>PDF Preview</p>
        <span
          style="
            cursor: pointer;
            position: absolute;
            top: 0px;
            right: 78px;
            font-size: 14px;
          "
          @click="download()"
          >Download PDF</span
        >
      </div>

      <div ref="printMe" class="printbox">
        <PreviewPanel :artwork="artwork" />
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import axios from "axios";
import PreviewPanel from "./PreviewPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";

export default {
  name: "AlbaPDFPreview",
  components: {
    PreviewPanel,
  },
  mixins: [artworkToProductMixin],
  data() {
    return {
      artwork: {},
      DownloaderBroadCast : new BroadcastChannel(this.$store.getters.downloaderBroadcastChannel(this.$route.query.c))
    };
  },

  methods: {
    back() {
      this.$router.back(-1);
    },
    download() {
      window.close();
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `pdf_${this.artwork._id}`, fileType: "pdf", fileName: this.artwork.name + ".pdf", data: this.artwork });
    },
  },

  created: function () {
    this.$parent.removeHeader();
  },

  async mounted() {
    var response = await axios.get("open/artwork/single/" + this.routeParamProductId);
    this.artwork = response.data;
    this.artwork.roomtype = this.$route.params.roomtype || "N/A";
    this.artwork.project = this.$route.params.project || "N/A";
    this.artwork.quantity = this.$route.params.qty || "N/A";
    this.$store.state.artwork = this.artwork;
  },
};
</script>

<style lang="css" scoped></style>
